<script setup>
/**
 * @fileoverview DialogDescription component
 * @description Description text for dialog
 */
import { DialogDescription as DialogDescriptionPrimitive } from 'radix-vue'
import { cn } from '@/lib/utils'

const props = defineProps({
  class: {
    type: String,
    default: ''
  }
})
</script>

<template>
  <DialogDescriptionPrimitive :class="cn('text-sm text-muted-foreground', props.class)">
    <slot />
  </DialogDescriptionPrimitive>
</template>
